import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { OuiStep } from 'omnium-ui/stepper';

interface StepWithPath {
  step: OuiStep;
  path: string;
}

@Component({
  selector: 'app-admin-page',
  templateUrl: './admin-page.component.html',
  styleUrls: ['./admin-page.component.scss'],
})
export class AdminPageComponent {
  constructor(private router: Router) {}
  items: StepWithPath[] = [
    { step: { state: 'doing', title: 'Administration fiches conseil' }, path: 'fiches' },
    { step: { state: 'doing', title: 'Fichiers allocation' }, path: 'fichiers-allocation' },
  ];

  steps = this.items.map(item => item.step);

  onStepChange(step: OuiStep) {
    // sur selection d'un step on met à jour la route
    const item = this.items.find(item => item.step.title === step.title);
    if (item && !this.router.url.includes(item.path)) {
      this.router.navigate([item.path]);
    }
  }
}
